/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains context used to share the Theme Manager.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Used to create a react context to share data throughout the react chain.
 */
import { createContext } from 'react';

/*
 * ---------------------------------------------------------------------------------
 * Imports - Internal
 * ---------------------------------------------------------------------------------
 */

/**
 * Typing and Initial Value of theme manager.
 */
import ThemeManager from 'src/style/ThemeManager';

/*
 * ---------------------------------------------------------------------------------
 * Constants
 * ---------------------------------------------------------------------------------
 */

const ThemeManagerContext = createContext<ThemeManager>(new ThemeManager());

/*
 * ---------------------------------------------------------------------------------
 * Exports - Default
 * ---------------------------------------------------------------------------------
 */

export default ThemeManagerContext;


// WEBPACK FOOTER //
// ./src/contexts/ThemeManagerContext.ts